import { render } from "./cp_SetByHotArea.vue?vue&type=template&id=3b563b68&scoped=true"
import script from "./cp_SetByHotArea.vue?vue&type=script&lang=js"
export * from "./cp_SetByHotArea.vue?vue&type=script&lang=js"

import "./cp_SetByHotArea.vue?vue&type=style&index=0&id=3b563b68&lang=less&scoped=true"

import exportComponent from "E:\\Project\\HZY\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b563b68"]])

export default __exports__